import { render, staticRenderFns } from "./DefaultCombobox.vue?vue&type=template&id=fd4b2b28&scoped=true"
import script from "./DefaultCombobox.vue?vue&type=script&lang=js"
export * from "./DefaultCombobox.vue?vue&type=script&lang=js"
import style0 from "./DefaultCombobox.vue?vue&type=style&index=0&id=fd4b2b28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4b2b28",
  null
  
)

export default component.exports